import JwtBaseClient from './JwtBaseClient';

/**
 * @class OrganizationServiceClient
 * @description API wrapper for Organization Service API
 */
class OrganizationServiceClient extends JwtBaseClient {
  constructor() {
    super(
      import.meta.env.VITE_ORGANIZATION_SERVICE_BASE_URI,
      'response.data',
    );
  }

  getDealershipAddresses(organizationId) {
    return this.get(`address/${organizationId}`);
  }

  getDealershipAddress(addressId) {
    return this.get(`address/byid/${addressId}`);
  }

  getPaginatedDealershipAddresses(organizationId, payload = {}) {
    const data = {
      page: payload.page || 0,
      pageSize: payload.pageSize || 10,
      includeTotalCount: payload.includeTotalCount || false,
      addressType: payload.addressType,
      filterValue: payload.filterValue,
    };
    return this.get(`address/${organizationId}/paginate`, data);
  }

  getDealershipPrimaryTransportationContact(organizationId) {
    return this.get(`/organization/${organizationId}/contacts/transportprimary`);
  }

  getDealership(organizationId) {
    return this.get(`organization/${organizationId}`);
  }

  getUserExists(emailAddress) {
    return this.get(`user/exists/${emailAddress}`);
  }
}

export default OrganizationServiceClient;
